<template lang="pug">
.icon-add(@click="$emit('add')")
  img(src="~assets/icons/add.png")
  
</template>
<script>
export default {
  name: 'IconAdd',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.icon-add
  width: pxToRem(205)
  height: pxToRem(205)
  line-height: 0
  img
    width: 100%
</style>
